import { Season } from '../types/shared/Season';
import DataStore from './DataStore';

const dataStore = DataStore.getInstance('app');

export function viewAsSeason(season: Season | null) {
  const user = dataStore.get('user');
  const account = dataStore.get('account');
  dataStore.clearAll();
  dataStore.set('user', user);
  dataStore.set('account', account);
  dataStore.set('season', season);
}
